import { createListLoadingReducer } from './utils';
import { BookingUserQueueItem } from '@/types';

export default createListLoadingReducer<BookingUserQueueItem>('BOOKING_USER_QUEUE');
